"use client";

import { useEffect, useState } from "react";

export function useStickyBarVisibility(targetSelector: string): boolean {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const el = document.querySelector(targetSelector);
		if (!el) return;

		const compute = (): void => {
			const rect = el.getBoundingClientRect();
			setVisible(rect.bottom <= 0);
		};

		let observer: IntersectionObserver | undefined;
		if (typeof IntersectionObserver !== "undefined") {
			observer = new IntersectionObserver(() => compute(), {
				threshold: 0
			});
			observer.observe(el);
		}

		document.addEventListener("scroll", compute, {
			capture: true,
			passive: true
		});
		window.addEventListener("resize", compute, { passive: true });

		compute();

		return () => {
			observer?.disconnect();
			document.removeEventListener("scroll", compute, {
				capture: true
			} as EventListenerOptions);
			window.removeEventListener("resize", compute);
		};
	}, [targetSelector]);

	return visible;
}
